/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/** Unique tabs using H6 as an anchor **/
document.addEventListener("DOMContentLoaded", function(event) { 
  $($('.product-single__content-text').find('h6').get().reverse()).each(function(i) {
      var tabName = $(this).text();
      tabContent = '';
      //check if h6 has text inside
    if ($(this).text() != '') {
          //hide h6
        $(this).hide();
          //combine content between H6 elements
          $(this).nextUntil('h6').each(function() {
              tabContent = tabContent + this.outerHTML;
              //hide content
              $(this).hide();
          });
          //generate tab HTML
          $('.product-single__accordion.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-unique-info" style="display:none;"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
          $('.product-single__accordion.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-unique-trigger"><div class="product-single__accordion__title-wrapper"><h3 class="product-single__accordion__title-text u-large f-family--body">' + tabName + '</h3><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></div></a>');
      } else {  
          //hide empty H6
          $(this).hide();
      }
  });
  $(".js-unique-trigger").click(function() {
    var thisItem = $(this).attr("href");
    var activeClass = "js-active";
    //check if clicked is active
    if ($(thisItem).hasClass(activeClass)) {
      //close current item
      $(this).removeClass(activeClass);
      $(thisItem)
      .removeClass(activeClass)
      .stop()
      .slideUp();
    } else {
      //open and activate this item
      $(thisItem)
      .addClass(activeClass)
      .stop()
      .slideDown();
      $(this).addClass(activeClass);
    }
    return false;
  });
});

/*-----------------------------------------------------------------------------/
/ In-stock by default (Search & Discovery native filters)
/ 1. Collections: add "In stock" on first landing, once per collection per
/    session, unless the URL already sets availability. A shopper who
/    unchecks it is not forced back into it.
/ 2. Search: every search form submits with "In stock" applied.
/ 3. Filter values with zero matching products are hidden, not greyed out.
/ 4. Homepage "Shop your size" buttons always link with "In stock" applied.
/-----------------------------------------------------------------------------*/
(function () {
  var PARAM = 'filter.v.availability';

  // 3. Hide zero-count filter values (theme marks them collection-sidebar__item--disabled)
  try {
    var style = document.createElement('style');
    style.textContent = '.collection-sidebar__item--disabled{display:none!important;}';
    document.head.appendChild(style);
  } catch (e) {}

  // 1. Collection pages
  try {
    var isEditor = window.Shopify && window.Shopify.designMode;
    var isCollection = /\/collections\/[^\/]+\/?$/.test(window.location.pathname);
    var hasAvailabilityFilter = !!document.querySelector('input[name="' + PARAM + '"]');
    if (!isEditor && isCollection && hasAvailabilityFilter) {
      var params = new URLSearchParams(window.location.search);
      var key = 'fgInStockDefault:' + window.location.pathname;
      if (!params.has(PARAM) && !window.sessionStorage.getItem(key)) {
        window.sessionStorage.setItem(key, '1');
        params.set(PARAM, '1');
        window.location.replace(window.location.pathname + '?' + params.toString() + window.location.hash);
        return;
      }
    }
  } catch (e) {}

  // 2. Search forms
  try {
    var forms = document.querySelectorAll('form[action$="/search"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('input[name="' + PARAM + '"]')) { continue; }
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = PARAM;
      input.value = '1';
      forms[i].appendChild(input);
    }
  } catch (e) {}

  // 4. Homepage size buttons
  try {
    var sizeLinks = document.querySelectorAll('.fg-size__grid a[href]');
    for (var j = 0; j < sizeLinks.length; j++) {
      var href = sizeLinks[j].getAttribute('href');
      if (href.indexOf(PARAM) === -1) {
        sizeLinks[j].setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + PARAM + '=1');
      }
    }
  } catch (e) {}
})();
